import { render } from "./Blockers.vue?vue&type=template&id=68e88059"
import script from "./Blockers.vue?vue&type=script&lang=js"
export * from "./Blockers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__